export const DOMAIN_NACE = "NACE";
